const getPaymentConfig = (methodByCurrency = {}, type) => {
  if (methodByCurrency[type]) {
    return methodByCurrency[type];
  }

  return methodByCurrency;
};

export default getPaymentConfig;
